import * as React from 'react';

import {Link, useLoaderData, useNavigate} from 'react-router-dom';
import {useMessage} from '../context/MessageProvider';
import {useAuth} from '../context/AuthProvider';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import { EditOutlined } from "@mui/icons-material";
import FormTextField from '../components/form/FormTextField';
import {useForm, FormProvider} from 'react-hook-form';
import Form from '../components/form/Form';
import FormButton from '../components/form/FormButton';
import FormDropDown from '../components/form/FormDropDown';

import Header from "../components/Header";
import Subheader from "../components/Subheader";

import { getAnimal, listAnimals, saveAnimal } from '../models/animals';
import {relationshipTypeList} from "../models/categories";
import GoBack from '../components/GoBack';
import {v4 as uuidv4} from 'uuid';
import { Button, Typography } from '@mui/material';

import { useConnectivity } from '../context/ConnectivityProvider';

const RelationshipEditForm = ({ relation, animalList, relationshipTypes, onEdit, onDelete, working }) => {
    const methods = useForm({ defaultValues: relation });
    return (
        <FormProvider {...methods}>
            <Form>
                <Grid container spacing={2} sx={{mb:2}}>
                    <Grid xs={6} sm={6} display="flex" justifyContent="center" alignItems="center">
                        <FormDropDown name="related_animal_id" label="Related Animal" list={animalList} required />
                    </Grid>
                    <Grid xs={6} sm={6} display="flex" justifyContent="center" alignItems="center">
                        <FormDropDown name="relationship_type" label="Relationship Type" list={relationshipTypes} required />
                    </Grid>
                    <Grid xs={12} sm={12} display="flex" justifyContent="center" alignItems="center">
                        <FormTextField name="description" label="Description"/>
                    </Grid>
                    <Grid xs={4} display="flex" justifyContent="center" alignItems="center">
                        <FormButton onSubmit={methods.handleSubmit(onEdit)} working={working}>Save</FormButton>
                    </Grid>
                    <Grid xs={4} display="flex" justifyContent="center" alignItems="center">
                        <FormButton onSubmit={methods.handleSubmit(onDelete)} working={working}>Delete</FormButton>
                    </Grid>
                </Grid>
            </Form>
        </FormProvider>
    );
};

// if you need to load data, you can use this template, note that the return value needs to be an object with named records in it.
export async function loader({params}) {
    console.log(params);
    if (!params.animalId) throw new Error("Need to pick a defined animal first");
    const animals = await listAnimals();
    const animal = await getAnimal(params.animalId);
    return {animals, animal, relationshipTypes:  await relationshipTypeList()};
}

export default function AnimalRelationshipsForm({title = "EWP",...props}) {
    const {setSuccess, setError} = useMessage();
    const [isEditing, setIsEditing] = React.useState(false)
    const [working, setWorking] = React.useState(false);
    const {facilityId} = useAuth();
    const {isOnline} = useConnectivity();
    const navigate = useNavigate();

    console.log("facilityId: ", facilityId);
    // used to read the loader data that is returned from the function above
    const {animals, animal, relationshipTypes} = useLoaderData(); 
    console.log("Animal Record: ", animal);

    const [list, setList] = React.useState(animal.relationships);


    // build the animal list to not have the animal in it
    const animalList = animals.map((cur)=>{
        return {
            label: cur.name,
            value: cur.id
        };
    }).filter((cur)=>{
        return cur.value !== animal.id;
    });

    console.log(animalList);

    const addMethods = useForm({ defaultValues: { related_animal_id: '', relationship_type: '' } });

    // handling an edit save
    const handleEdit = async (data) => {
        try {
            setWorking(true);
            console.log(data);
            console.log(list);

            const temp = [...list.filter((cur)=>{
                return cur.id !== data.id;
            }),data];

            console.log(temp);
            setList(temp);
            animal.relationships = temp;
            await saveAnimal(animal,facilityId,isOnline);
            setSuccess("Animal Saved");
        } catch (error) {
            setError(error);
        } finally {
            setWorking(false);
        }
    }

    // handle a remove
    const handleDelete = async(data)=>{
        try {
            setWorking(true);
            console.log("delete", data);

            const temp = [...list.filter((cur)=>{
                return cur.id !== data.id;
            })];

            console.log(temp);
            setList(temp);
            animal.relationships = temp;
            await saveAnimal(animal,facilityId, isOnline);
            setSuccess("Animal Saved");
        } catch (error) {
            setError(error);
        } finally {
            setWorking(false);
        }
    }


    // handle an add
    const handleAdd= async (data) => {
        try {
            setWorking(true);

            data.id = uuidv4(); // have to assign the ID here, since we need it for filtering, if they add, then edit or remove
            data.animal_id = animal.id;
            const temp = [...list,data]

            console.log(temp);
            setList(temp);
            animal.relationships = temp;
            await saveAnimal(animal,facilityId,isOnline);
            setSuccess("Animal Saved");
        } catch (error) {
            setError(error);
        } finally {
            setWorking(false);
        }

    }

    // note you can play with the container maxwidth to spread out the window content appears in
    return (
        <Container component="main" maxWidth="sm">
            <GoBack onClick={()=>navigate(`/animals/${animal.id}`)} />
            <Header label={title} />

            <Subheader label={animal.name} />

            <Subheader label="New Relationship" />

            <FormProvider {...addMethods}>
                <Form onSubmit={addMethods.handleSubmit(handleAdd)}>
                    <Grid container spacing={2}>
                        <Grid xs={6} sm={6} display="flex" justifyContent="center" alignItems="center">
                            <FormDropDown name="related_animal_id" label="Related Animal" list={animalList} required />
                        </Grid>
                        <Grid xs={6} sm={6} display="flex" justifyContent="center" alignItems="center">
                            <FormDropDown name="relationship_type" label="Relationship Type" list={relationshipTypes} required />
                        </Grid>
                        <Grid xs={12} sm={12} display="flex" justifyContent="center" alignItems="center">
                            <FormTextField name="description" label="Description"/>
                        </Grid>
                        <Grid xs={2} display="flex" justifyContent="center" alignItems="center">
                            <FormButton working={working}>Add</FormButton>
                        </Grid>
                    </Grid>
                </Form>
            </FormProvider>
            <Grid container alignItems={"center"} justifyContent="space-between">
                <Subheader label="Existing Relationships" />
                <Button onClick={()=>{setIsEditing(!isEditing)}} variant={!isEditing?'contained':'outlined'}>
                <EditOutlined/>
                </Button>
            </Grid>
           {
            isEditing?
            list.map((relation)=>
                <RelationshipEditForm
                    key={relation.id}
                    relation={relation}
                    animalList={animalList}
                    relationshipTypes={relationshipTypes}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    working={working}
                />
            )
            :
            <>
            <Grid container display="flex" sx={{pl:2, pr:2,mt:2}} justifyContent="space-between" alignItems="center">
            <Grid xs={9}display="flex" alignItems="center">
                    <Typography fontWeight="bold" sx={{color:""}}>Name</Typography>
                </Grid>
                <Grid xs={3} display="flex"  alignItems="center">
                    <Typography fontWeight="bold" sx={{color:""}}>Relationship</Typography>
                </Grid>
            </Grid>
            {list.map(el=>
            
            <Grid container justifyContent="space-between" sx={{position:"relative",border:"1px solid #f1f1f1",borderRadius:2, mt:2,mb:2, p:2}}>


                <Grid xs={9}display="flex" alignItems="center">
                    <Link style={{color:"#00554a"}} to={`/animals/${el.related_animal_id}`}><Typography>{animalList.find((cur)=>{return cur.value === el.related_animal_id}).label}</Typography></Link>
                </Grid>
                <Grid xs={3} display="flex"  alignItems="center">
                    <Typography>{relationshipTypes.find((cur)=>{return cur.value === el.relationship_type})?.label || "not found"}</Typography>
                </Grid>
              {
                el.description&&  
                <>
                    <Typography fontWeight="bold" sx={{fontSize:"0.8rem",mt:2}}>Description</Typography>
                    <Grid xs={12} display="flex"  alignItems="center">
                        <Typography>{el.description}</Typography>
                    </Grid>
                </>
              }
            </Grid>
            )
           }
           </>
}


        </Container>
    );
}